import { useSelector } from "react-redux";
import { RootState } from "../redux/reducer";

const useLoggedUser = () => {
  const loggedUser = useSelector<RootState, any>((state) => state.loggedUser);
  return loggedUser;
};

export default useLoggedUser;
